import { useQuery } from 'react-query';

import { getSuggestedAiPrompts } from '@utils/backend-api/suggestedAiPrompts';

export const AI_THREADS_KEY = 'AI_THREADS';
export const SUGGESTED_AI_PROMPTS_KEY = 'SUGGESTED_AI_PROMPTS';

export function useSuggestedAiPrompts() {
  const { data, isLoading } = useQuery(SUGGESTED_AI_PROMPTS_KEY, async () => {
    return await getSuggestedAiPrompts();
  });

  return {
    suggestedAiPrompts: data?.suggestedAiPrompts || [],
    isLoadingSuggestedAiPrompts: isLoading,
  };
}
